import { type ReactNode, useEffect } from 'react';
import { cn } from '@/lib/utils.ts';

export const APP_NAME = 'Bare Naked Birdies';

/** Sets the browser tab title; every title ends with the brand name (smoke tests rely on it). */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : `${APP_NAME} Planner`;
  }, [title]);
}

/**
 * Page title block: eyebrow (section group) + Sanchez caps title + one-line lede.
 * One per screen. Actions (buttons, chips) sit on the right on wide screens.
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  className,
}: {
  eyebrow?: ReactNode;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  useDocumentTitle(title);
  return (
    <header
      className={cn(
        'flex flex-wrap items-end justify-between gap-x-6 gap-y-3 border-line-strong border-b pb-5',
        className,
      )}
    >
      <div className="grid min-w-0 gap-1.5">
        {eyebrow ? <p className="type-eyebrow">{eyebrow}</p> : null}
        <h1 className="type-page">{title}</h1>
        {description ? <p className="max-w-[68ch] text-ink-2">{description}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </header>
  );
}
